/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Вид банковской справки
 */
export interface ReferenceOrder {
  /**
   * Цифровой код вида справки
   * @example 1
   */
  code: string;

  /**
   * Описание вида справки
   * @example об остатке по счету
   */
  desc?: string;

  /**
   * Вид справки - Другая справка
   * @example false
   */
  other?: boolean;
}

/**
 * Запрос на создание/редактирование заявки на получение банковских справок
 */
export interface ReferenceOrderRequest {
  /**
   * Идентификатор дополнительного офиса для получения справок
   * @format uuid
   * @example 01a92e98-1a82-42e3-9347-27c083f73503
   */
  branchId: string;

  /**
   * Признак "С тарифами Банка ознакомлен и согласен"
   * @example true
   */
  tariffsAgreement: boolean;

  /** Расчётные счета клиента */
  accountNumbers?: string[];

  /** Виды банковских справок */
  requestText: ReferenceOrder[];

  /**
   * Признак игнорирования предупреждений валидации
   * @example false
   */
  ignoreWarning: boolean;
}

/**
 * Разрешения пользователя
 */
export interface AccessRights {
  /** Разрешение на подпись */
  canSign: boolean;

  /** Комментарий к разрешению на подпись */
  canSignDesc?: string;

  /** Разрешение на редактирование */
  canEdit: boolean;

  /** Разрешение на удаление */
  canDelete: boolean;

  /** Разрешение на отзыв документа */
  canRevoke: boolean;
}

/**
 * Ответ на создание/редактирование заявки на получение банковских справок
 */
export interface ReferenceOrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Номер заявки */
  number?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  date?: string;

  /** Статус заявки */
  state?: string;

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

/**
 * Сообщение об ошибкe валидации
 */
export interface ValidationErrorItem {
  /** Сообщение об ошибке */
  message?: string;

  /** Поля, содержащие ошибку */
  fields?: string[];
}

/**
 * Сообщение об ошибках валидации
 */
export interface ValidationErrorMessage {
  /** Ошибки валидации */
  errors?: ValidationErrorItem[];

  /** Предупреждения валидации */
  warnings?: ValidationErrorItem[];

  /** Дата и время возникновения ошибок валидации */
  timestamp?: string;
}

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentSave {
  /**
   * Идентификатор вложения
   * @format uuid
   */
  id?: string;

  /** Имя файла */
  fileName: string;

  /** Файл в формате base64 */
  encodedString: string;
}

/**
 * Обоснование получения денежных средств
 */
export interface CashDirection {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Кассовый символ */
  symbol: string;

  /** Сумма наличных */
  amount: number;

  /** Описание */
  name: string;
}

/**
 * Сущность для заказа наличных - монеты, банкноты
 */
export interface CashNominal {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Тип номинала */
  cashNominalType: "COIN" | "BANKNOTE";

  /**
   * Количество наличных по выбранному номиналу
   * @format int64
   */
  count: number;

  /** Номинал выбранных наличных */
  amount: string;
}

/**
 * Запрос на создание заявки на выдачу наличных в ДО
 */
export interface CashWithdrawalOrderRequest {
  /**
   * Дата выдачи наличных
   * @format date
   */
  dateCashIssue: string;

  /** Номер счёта для списания и выдачи наличных */
  accountNumber: string;

  /**
   * Идентификатор филиала получения
   * @format uuid
   */
  branchIssueId: string;

  /** Сумма выдачи наличных */
  amountIssue: number;

  /** Предварительная сумма комиссии */
  preliminaryCommissionAmount: number;

  /** Данные получателя наличных */
  receiverInfo: ReceiverInfo;
  cashNominalList?: CashNominal[];
  cashDirectionList: CashDirection[];
  attachmentSaveList?: AttachmentSave[];
}

/**
 * Данные получателя наличных
 */
export interface ReceiverInfo {
  /** ФИО получателя */
  fullName: string;

  /** Серия паспорта */
  passportSerial: string;

  /** Номер паспорта */
  passportNumber: string;

  /**
   * Дата получения паспорта
   * @format date
   */
  passportIssueDate: string;

  /** Место получения паспорта */
  passportIssuePlace: string;
}

/**
 * Заявки на заключение кредитной сделки
 */
export interface GetCreditTransactionOrdersResponse {
  /** Наличие у пользователя права на создание новых Заявок */
  canCreate?: boolean;

  /** Наличие у пользователя права на подпись Заявок */
  canSign?: boolean;

  /** Признак наличия следующей страницы справок при постраничной выдаче */
  hasMore?: boolean;

  /** Перечень Заявок на открытие счёта */
  orders?: CreditTransactionOrderResponse[];
}

export interface CreditTransactionOrderRequest {
  /**
   * Номер заявки
   * @format int32
   */
  orderNumber: number;

  /** ФИО уполномоченного лица */
  authorisedPersonName: string;

  /** Телефон уполномоченного лица */
  authorisedPersonPhone: string;

  /** Сумма */
  amount: number;

  /** Цифровой код валюты */
  currencyCode: string;

  /**
   * Дата погашения
   * @format date
   */
  maturityDate: string;

  /**
   * Дата заключения сделки
   * @format date
   */
  submissionDate: string;

  /** Процентная ставка */
  interestRate: string;

  /** База расчета процентов */
  interestCalculationBasis: string;

  /** Тип уплаты процентов */
  interestPaymentType: string;

  /** Счёт для перечисления */
  transferAccount: string;

  /** Флаг перевода внутри банка */
  isIntraBankTransfer: boolean;

  /** Флаг возможности досрочного погашения */
  isRightEarlyRepayment: boolean;

  /** Наименование клиента в другом банке */
  clientNameInAnotherBank?: string;

  /** БИК банка для перечисления */
  transferBic?: string;

  /**
   * Дата заключения договора о возможности операции кредитования
   * @format date
   */
  conclusionContractDate: string;

  /** Номер заключения договора о возможности операции кредитования */
  conclusionContractNumber: string;
}

/**
 * Ответ на создание/редактирование заявки на заключение кредитной сделки
 */
export interface CreditTransactionOrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Номер заявки */
  number?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  date?: string;

  /** Статус заявки */
  state?: string;

  /** Номер счёта для перевода денежных средств */
  accountNumber?: string;

  /** Сумма кредита */
  amount?: number;

  /** Наименование филиала */
  branchName?: string;

  /** Адрес филиала */
  branchAddress?: string;

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

export interface CreditTransactionOrderInfoResponse {
  /** @format uuid */
  id?: string;

  /**
   * Номер
   * @format int32
   */
  number?: number;

  /**
   * Дата
   * @format date
   */
  date?: string;

  /** Статус */
  state?: string;

  /** Номер счёта для перевода денежных средств */
  transferAccount?: string;

  /** БИК банка для перевода денежных средств */
  transferBic?: string;

  /** Корр. счёт банка для перевода денежных средств */
  transferCorrespondentAccount?: string;

  /** Наименование банка для перевода денежных средств */
  transferBankName?: string;

  /** Сумма кредита */
  amount?: number;

  /** Код валюты */
  currencyCode?: string;

  /** Наименование филиала */
  branchName?: string;

  /** Адрес филиала */
  branchAddress?: string;

  /** Наименование клиента */
  clientName?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** КПП клиента */
  clientKpp?: string;

  /**
   * Дата погашения
   * @format date
   */
  maturityDate?: string;

  /**
   * Дата предоставления
   * @format date
   */
  submissionDate?: string;

  /** Процентная ставка */
  interestRate?: string;

  /** База расчета процентов */
  interestCalculationBasis?: string;

  /** Тип уплаты процентов */
  interestPaymentType?: string;

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;

  /** Телефон должностного лица */
  authorisedPersonPhone?: string;

  /** Наименование должностного лица */
  authorisedPersonName?: string;

  /**
   * Дата заключения договора кредитного обслуживания с банком
   * @format date
   */
  conclusionContractDate?: string;

  /** Номер договора кредитного обслуживания с банком */
  conclusionContractNumber?: string;

  /** Признак перевода внутри банка */
  isIntraBankTransfer?: boolean;

  /** Флаг возможности досрочного погашения */
  isRightEarlyRepayment?: boolean;

  /** Наименование клиента в другом банке */
  clientNameInAnotherBank?: string;

  /** Причина отказа в оказании услуги */
  rejectReason?: string;
}

/**
 * Ответ на создание/редактирование заявки на выдачу наличных
 */
export interface CashWithdrawalOrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Номер заявки */
  number?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  date?: string;

  /** Статус заявки */
  state?: string;

  /** Номер счёта */
  accountNumber?: string;

  /** Сумма выдачи наличных */
  amountIssue?: number;

  /** Наименование офиса */
  branchIssueName?: string;

  /** Адрес офиса */
  branchIssueAddress?: string;

  /**
   * Идентификатор отзыва
   * @format uuid
   */
  revokeId?: string;

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

/**
 * Запрос на создание заявки на открытие счёта
 */
export interface AccountOpenOrderRequest {
  /**
   * Признак согласия с тарифами Банка и условиями открытия и ведения счетов
   * @example true
   */
  acceptAgreement: boolean;

  /**
   * Признак игнорирования предупреждений валидации
   * @example false
   */
  ignoreWarning: boolean;

  /** Признак использования тарифного плана */
  isTariffPlan: boolean;

  /**
   * Код тарифного плана
   * @example 11
   */
  tariffPlanCode?: string;

  /**
   * Код типа расчётного счёта
   * @example 6
   */
  accountType?: string;

  /** Расчётный период */
  accountPeriod?: string;

  /**
   * Валюта расчётного счёта
   * @example RUR
   */
  accountCurrency: string;
}

/**
 * Ответ на создание/редактирование заявки на открытие счёта
 */
export interface AccountOpenOrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Номер заявки */
  number?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  date?: string;

  /** Статус заявки */
  state?: string;

  /** Комментарий к статусу заявки */
  stateDesc?: string;

  /** Признак использования тарифного плана */
  isTariffPlan?: boolean;

  /** Код тарифного плана */
  tariffPlanCode?: string;

  /** Код типа расчётного счёта */
  accountType?: string;

  /** Расчётный период */
  accountPeriod?: string;

  /** Номер договора РКО */
  accountAgreementNumber?: string;

  /**
   * Дата договора РКО
   * @format date
   */
  accountAgreementDate?: string;

  /** Номер открытого расчётного счёта */
  accountNumber?: string;

  /** Текст клиентского соглашения (список абзацев) */
  agreement?: string[];

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

/**
 * Запрос на создание заявки на подключение/отключение услуги Проверка контрагентов
 */
export interface ContragentOrderRequest {
  /** Руководитель/уполномоченное лицо клиента */
  responsibleName?: string;

  /**
   * Признак игнорирования предупреждений валидации
   * @example false
   */
  ignoreWarning: boolean;

  /** Вид заявки, CORRESPONDENT_CHECK_ON/CORRESPONDENT_CHECK_OFF, подключение/отключение */
  contragentOrderKind: ContragentOrderType;
}

/**
 * Вид заявки, CORRESPONDENT_CHECK_ON/CORRESPONDENT_CHECK_OFF, подключение/отключение
 */
export enum ContragentOrderType {
  CORRESPONDENT_CHECK_ON = "CORRESPONDENT_CHECK_ON",
  CORRESPONDENT_CHECK_OFF = "CORRESPONDENT_CHECK_OFF",
}

/**
 * Ответ на создание заявки на подключение/отключение услуги Проверка контрагентов
 */
export interface ContragentOrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Номер заявки */
  number?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  date?: string;

  /** Руководитель/уполномоченное лицо клиента */
  responsibleName?: string;

  /** Статус заявки */
  state?: string;

  /** Разрешения пользователя */
  accessRights?: AccessRights;

  /** Вид заявки, CORRESPONDENT_CHECK_ON/CORRESPONDENT_CHECK_OFF, подключение/отключение */
  contragentOrderKind?: ContragentOrderType;
}

/**
 * Отзыв по заявке на выдачу наличных в ДО
 */
export interface RevokeCashWithdrawalOrderRequest {
  /** @format uuid */
  requestId?: string;
  reason?: string;
}

/**
 * Ответ по запросу создания отзыва на заявку выдачи наличных в ДО
 */
export interface RevokeCashWithdrawalOrderResponse {
  /**
   * Идентификатор отзыва
   * @format uuid
   */
  id?: string;

  /** Номер отзыва */
  number?: string;

  /**
   * Идентификатор отзываемого документа
   * @format uuid
   */
  revokeOrderId?: string;

  /**
   * Дата создания отзыва
   * @format date
   */
  date?: string;

  /** Статус отзыва */
  state?: string;

  /** Причина отзыва */
  reason?: string;

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

/**
 * Кассовый символ для комиссии
 */
export interface CashSymbolCommission {
  symbol?: string;
  amount?: number;
}

/**
 * Запрос комиссии и актуального остатка из ЦФТ для создания заявки на выдачу наличных в ДО
 */
export interface GetCommissionAmountRequest {
  accountNumber?: string;
  totalAmount?: number;
  cashSymbolList?: CashSymbolCommission[];
}

/**
 * Ответ от ЦФТ по комиссии и доступному остатку
 */
export interface GetCommissionAmountResponse {
  availableBalanceAmount?: number;
  calculateCommissionAmount?: number;
}

/**
 * Заявка на получение банковских справок
 */
export interface GetReferenceOrderResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Номер заявки */
  number?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  date?: string;

  /**
   * Дата исполнения заявки
   * @format date
   */
  processDate?: string;

  /** Статус заявки */
  state?: string;

  /** Описание статуса заявки */
  stateDesc?: string;

  /**
   * Идентификатор дополнительного офиса для получения справок
   * @format uuid
   */
  branchId?: string;

  /** Расчётные счета клиента */
  accountNumbers?: string[];

  /** Виды банковских справок */
  textOrders?: ReferenceOrder[];

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

/**
 * Заявки на получение банковских справок
 */
export interface GetReferenceOrdersResponse {
  /** Наличие у пользователя права на создание новых Заявок */
  canCreate?: boolean;

  /** Наличие у пользователя права на подпись Заявок */
  canSign?: boolean;

  /** Признак наличия следующей страницы справок при постраничной выдаче */
  hasMore?: boolean;

  /** Перечень Заявок на получение банковских справок */
  orders?: GetReferenceOrderResponse[];
}

/**
 * Вид банковской справки
 */
export interface ReferenceType {
  /**
   * Цифровой код вида справки
   * @format int32
   */
  code?: number;

  /** Наименование вида справки */
  name?: string;

  /** Признак Обязателен выбор расчётного счёта */
  mandatoryAccountSelection?: boolean;

  /** Признак Обязательно клиентское описание */
  mandatoryClientNote?: boolean;
}

/**
 * Договор ЕСД клиента
 */
export interface Esd {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Номер договора ЕСД */
  number?: string;

  /**
   * Дата договора ЕСД
   * @format date
   */
  date?: string;
}

/**
 * Доступный номинал монет и купюр
 */
export interface Denomination {
  /** Доступный номинал монет */
  coinDenomination?: string[];

  /** Доступный купюр монет */
  banknoteDenomination?: string[];
}

/**
 * Пользователи клиента
 */
export interface Delegate {
  /**
   * Идентификатор
   * @format uuid
   */
  delegateId?: string;

  /** Полное имя (ФИО) */
  fullName?: string;

  /** Номер паспорта */
  dulNumber?: string;

  /** Серия паспорта */
  dulSerial?: string;

  /**
   * Дата выдачи паспорта
   * @format date
   */
  dulIssueDate?: string;

  /** Место выдачи паспорта */
  dulIssue?: string;
}

/**
 * Кассовый символ
 */
export interface CashSymbol {
  /** Код кассового символа */
  symbol?: string;

  /** Описание кассового символа */
  name?: string;
}

/**
 * Дополнительный офис филиала клиента
 */
export interface Branch {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Наименование */
  name?: string;

  /** БИК */
  bic?: string;

  /** Адрес */
  address?: string;

  /** Время работы */
  operationTimeWork?: string;
}

/**
 * Текст клиентского соглашения
 */
export interface Agreement {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Вид клиентского соглашения */
  kind?: AgreementKind;

  /** Абзацы текста клиентского соглашения */
  items?: string[];
}

/**
 * Вид клиентского соглашения
 * @example AccountOpenOrder
 */
export enum AgreementKind {
  ACCOUNT_OPEN_ORDER = "ACCOUNT_OPEN_ORDER",
}

/**
 * Расчётный счёт клиента
 */
export interface Account {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Наименование */
  name?: string;

  /** ФИО подопечного */
  wardName?: string;

  /** Номер */
  number?: string;

  /** Буквенный ISO-код валюты */
  currency?: string;

  /** Текущий остаток */
  currentBalance?: number;
}

/**
 * Тип расчётного счёта
 */
export interface AccountType {
  /** Код типа */
  code?: string;

  /** Наименование типа */
  name?: string;
}

/**
 * Тарифный план расчётного счёта
 */
export interface AccountTariffPlan {
  /** Код тарифного плана */
  code?: string;

  /** Наименование тарифного плана */
  name?: string;
}

/**
 * Расчётный период расчётного счёта
 */
export interface AccountPeriod {
  /** Код расчётного периода */
  code?: string;
}

/**
 * Статус услуги Проверка контрагентов, OPENED/CLOSED/STOPPED, подключена/отключена/приостановлена
 */
export enum ContragentServiceState {
  OPENED = "OPENED",
  CLOSED = "CLOSED",
  STOPPED = "STOPPED",
}

/**
 * Заявки на подключение/отключение услуги Проверка контрагентов
 */
export interface GetContragentOrdersResponse {
  /** Наличие у пользователя права на создание новых Заявок */
  canCreate?: boolean;

  /** Наличие у пользователя права на подпись Заявок */
  canSign?: boolean;

  /** Признак наличия следующей страницы справок при постраничной выдаче */
  hasMore?: boolean;

  /** Перечень Заявок на получение банковских справок */
  orders?: ContragentOrderResponse[];

  /** Статус услуги Проверка контрагентов, OPENED/CLOSED/STOPPED, подключена/отключена/приостановлена */
  contragentServiceState?: ContragentServiceState;
}

/**
 * Документ
 */
export interface CcbDocument {
  /** Поля документа */
  fields?: CcbOrder;

  /** Тип документа */
  type?: DocumentType;
}

/**
 * Поля документа
 */
export type CcbOrder = object;

/**
 * Получение ККБ конкретного документа
 */
export interface DocumentCcbResponse {
  /** ККБ документа */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  ccbOrderDto?: CcbDocument;
}

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование вида заявки */
  name?: string;

  /** Описание вида заявки */
  desc?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId: string;
}

/**
 * Заявки на выдачу наличных в ДО
 */
export interface GetCashWithdrawalOrderResponse {
  /** Наличие у пользователя права на создание новых Заявок */
  canCreate?: boolean;

  /** Наличие у пользователя права на подпись Заявок */
  canSign?: boolean;

  /** Признак наличия следующей страницы справок при постраничной выдаче */
  hasMore?: boolean;

  /** Перечень Заявок */
  orders?: CashWithdrawalOrderResponse[];
}

/**
 * Информация о вложении
 */
export interface Attachment {
  /** Идентификатор вложения */
  id: string;

  /**
   * Идентификатор документа к которому прикреплено вложение
   * @format uuid
   */
  documentId: string;

  /** Готовность файла */
  ready: boolean;

  /** Код ошибки */
  errorCode?: string;

  /** Текст ошибки */
  errorDescription?: string;

  /**
   * Размер
   * @format int64
   */
  size?: number;

  /** Имя файла */
  fileName: string;
}

/**
 * Полная информация заявки на выдачу наличных в ДО
 */
export interface CashWithdrawalOrderInfoResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Номер заявки */
  number?: string;

  /**
   * Дата создания заявки
   * @format date
   */
  date?: string;

  /**
   * Дата выдачи наличных
   * @format date
   */
  dateCashIssue?: string;

  /** Номер счёта для списания денежных средств */
  accountNumber?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** КПП клиента */
  clientKpp?: string;

  /** Статус заявки */
  state?: string;

  /** Сумма выдачи наличных */
  amountIssue?: number;

  /** Предварительная сумма комиссии */
  preliminaryCommissionAmount?: number;

  /**
   * Идентификатор офиса получения
   * @format uuid
   */
  branchIssueId?: string;

  /** Наименование офиса получения */
  branchIssueName?: string;

  /** Адрес офиса получения */
  branchIssueAddress?: string;

  /**
   * Идентификатор отзыва
   * @format uuid
   */
  revokeId?: string;

  /** Данные получателя наличных */
  receiverInfo?: ReceiverInfo;
  cashNominalList?: CashNominal[];
  cashDirectionList?: CashDirection[];
  attachmentSaveList?: Attachment[];

  /** Причина отказа */
  rejectReason?: string;

  /** Разрешения пользователя */
  delegatePermissions?: AccessRights;
}

/**
 * Заявки на открытие счёта
 */
export interface GetAccountOpenOrdersResponse {
  /** Наличие у пользователя права на создание новых Заявок */
  canCreate?: boolean;

  /** Наличие у пользователя права на подпись Заявок */
  canSign?: boolean;

  /** Признак наличия следующей страницы справок при постраничной выдаче */
  hasMore?: boolean;

  /** Перечень Заявок на открытие счёта */
  orders?: AccountOpenOrderResponse[];
}

export type EmptyResponse = object;

export interface GetReferenceOrderParams {
  updateSignState?: boolean;

  /** @format uuid */
  orderId: string;
}

export interface UpdateInitReplicationParams {
  topic: string;
  exec: boolean;
}

export interface GetCashWithdrawalOrderByIdParams {
  updateSignState?: boolean;

  /** @format uuid */
  orderId: string;
}

export interface GetAccountOpenOrderParams {
  updateSignState?: boolean;

  /** @format uuid */
  orderId: string;
}

export interface GetReferenceOrdersParams {
  state?: string;

  /** @format int32 */
  page?: number;

  /** @format int32 */
  size?: number;
}

export interface GetContragentOrdersParams {
  state?: string;

  /** @format int32 */
  page?: number;

  /** @format int32 */
  size?: number;
}

export interface GetCashWithdrawalOrderByPositionParams {
  state?: string;

  /** @format int32 */
  page?: number;

  /** @format int32 */
  size?: number;
}

export interface GetAccountOpenOrdersParams {
  state?: string;

  /** @format int32 */
  page?: number;

  /** @format int32 */
  size?: number;
}

export interface GetAgreementParams {
  kind: "ACCOUNT_OPEN_ORDER";
}

export interface GetAccountsParams {
  orderType?: "CASH_WITHDRAWAL" | "ACCOUNT_OPEN";
}

export interface GetRevokeCashWithdrawalOrderCcbParams {
  /** @format uuid */
  revokeId: string;
}

export interface GetReferenceOrderCcbParams {
  /** @format uuid */
  orderId: string;
}

export interface GetCashWithdrawalOrderCcbParams {
  /** @format uuid */
  orderId: string;
}

export interface GetAccountOpenOrderCcbParams {
  /** @format uuid */
  orderId: string;
}

export interface GetConteragentServiceOrderCcbParams {
  /** @format uuid */
  orderId: string;
}

export interface GetRevokeByRevokeIdParams {
  updateSignState?: boolean;

  /** @format uuid */
  revokeId: string;
}

export interface GetCreditTransactionalByIdParams {
  updateSignState?: boolean;

  /** @format uuid */
  orderId: string;
}

export interface GetCreditTransactionOrderByPositionParams {
  state?: string;

  /** @format int32 */
  page?: number;

  /** @format int32 */
  size?: number;
}

export interface GetCreditTransactionOrderCcbParams {
  /** @format uuid */
  orderId: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-references
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-references.ndbo.dev.rshbdev.ru
 * @contact Ссылка на проект в JIRA (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=219590333&src=contextnavpagetreemode)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Заявки на получение банковских справок
     * @name GetReferenceOrder
     * @summary Получение заявки на получение банковских справок
     * @request GET:/api/rko-orders/v1/external/reference-order/{orderId}
     * @secure
     */
    getReferenceOrder: (
      { orderId, ...query }: GetReferenceOrderParams,
      params: RequestParams = {}
    ) =>
      this.request<GetReferenceOrderResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/reference-order/${orderId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на получение банковских справок
     * @name EditReferenceOrder
     * @summary Редактирование заявки на получение банковских справок
     * @request PUT:/api/rko-orders/v1/external/reference-order/{orderId}
     * @secure
     */
    editReferenceOrder: (
      orderId: string,
      data: ReferenceOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ReferenceOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/reference-order/${orderId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на получение банковских справок
     * @name DeleteReferenceOrder
     * @summary Удаление заявки на получение банковских справок
     * @request DELETE:/api/rko-orders/v1/external/reference-order/{orderId}
     * @secure
     */
    deleteReferenceOrder: (orderId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/reference-order/${orderId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name GetInitReplication
     * @summary БД инициализации репликации
     * @request GET:/api/rko-orders/v1/external/db/init-repl
     * @secure
     */
    getInitReplication: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/init-repl`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name UpdateInitReplication
     * @summary Значение БД инициализации репликации
     * @request PUT:/api/rko-orders/v1/external/db/init-repl
     * @secure
     */
    updateInitReplication: (
      query: UpdateInitReplicationParams,
      params: RequestParams = {}
    ) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/init-repl`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name GetCashWithdrawalOrderById
     * @summary Получение Заявки на выдачу наличных в офисе банка по идентификатору
     * @request GET:/api/rko-orders/v1/external/cash-withdrawal-order/{orderId}
     * @secure
     */
    getCashWithdrawalOrderById: (
      { orderId, ...query }: GetCashWithdrawalOrderByIdParams,
      params: RequestParams = {}
    ) =>
      this.request<CashWithdrawalOrderInfoResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/${orderId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name EditCashWithdrawalOrder
     * @summary Редактирование Заявки на выдачу наличных в офисе банка
     * @request PUT:/api/rko-orders/v1/external/cash-withdrawal-order/{orderId}
     * @secure
     */
    editCashWithdrawalOrder: (
      orderId: string,
      data: CashWithdrawalOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        CashWithdrawalOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/${orderId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name DeleteCashWithdrawalOrderById
     * @summary Удаление Заявки на выдачу наличных в офисе банка
     * @request DELETE:/api/rko-orders/v1/external/cash-withdrawal-order/{orderId}
     * @secure
     */
    deleteCashWithdrawalOrderById: (
      orderId: string,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/${orderId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие счёта
     * @name GetAccountOpenOrder
     * @summary Получение заявки на открытие счёта
     * @request GET:/api/rko-orders/v1/external/account-open-order/{orderId}
     * @secure
     */
    getAccountOpenOrder: (
      { orderId, ...query }: GetAccountOpenOrderParams,
      params: RequestParams = {}
    ) =>
      this.request<AccountOpenOrderResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/account-open-order/${orderId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие счёта
     * @name EditAccountOpenOrder
     * @summary Редактирование заявки на открытие счёта
     * @request PUT:/api/rko-orders/v1/external/account-open-order/{orderId}
     * @secure
     */
    editAccountOpenOrder: (
      orderId: string,
      data: AccountOpenOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        AccountOpenOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/account-open-order/${orderId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие счёта
     * @name DeleteAccountOpenOrder
     * @summary Удаление заявки на открытие счёта
     * @request DELETE:/api/rko-orders/v1/external/account-open-order/{orderId}
     * @secure
     */
    deleteAccountOpenOrder: (orderId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/account-open-order/${orderId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на получение банковских справок
     * @name GetReferenceOrders
     * @summary Получение заявок на получение банковских справок
     * @request GET:/api/rko-orders/v1/external/reference-order
     * @secure
     */
    getReferenceOrders: (
      query: GetReferenceOrdersParams,
      params: RequestParams = {}
    ) =>
      this.request<
        GetReferenceOrdersResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/reference-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на получение банковских справок
     * @name CreateReferenceOrder
     * @summary Создание заявки на получение банковских справок
     * @request POST:/api/rko-orders/v1/external/reference-order
     * @secure
     */
    createReferenceOrder: (
      data: ReferenceOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ReferenceOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/reference-order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на подключение/отключение услуги Проверка контрагентов
     * @name GetContragentOrders
     * @summary Получение заявок на подключение/отключение услуги Проверка контрагентов
     * @request GET:/api/rko-orders/v1/external/contragent-order
     * @secure
     */
    getContragentOrders: (
      query: GetContragentOrdersParams,
      params: RequestParams = {}
    ) =>
      this.request<
        GetContragentOrdersResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/contragent-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на подключение/отключение услуги Проверка контрагентов
     * @name CreateContragentOrder
     * @summary Создание заявки на подключение/отключение услуги Проверка контрагентов
     * @request POST:/api/rko-orders/v1/external/contragent-order
     * @secure
     */
    createContragentOrder: (
      data: ContragentOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ContragentOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/contragent-order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name GetCashWithdrawalOrderByPosition
     * @summary Получение Заявок на выдачу наличных в офисе банка
     * @request GET:/api/rko-orders/v1/external/cash-withdrawal-order
     * @secure
     */
    getCashWithdrawalOrderByPosition: (
      query: GetCashWithdrawalOrderByPositionParams,
      params: RequestParams = {}
    ) =>
      this.request<
        GetCashWithdrawalOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name CreateCashWithdrawalOrder
     * @summary Создание Заявки на выдачу наличных в офисе банка
     * @request POST:/api/rko-orders/v1/external/cash-withdrawal-order
     * @secure
     */
    createCashWithdrawalOrder: (
      data: CashWithdrawalOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        CashWithdrawalOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name CreateRevokeCashWithdrawalOrder
     * @summary Создание отзыва заявки на выдачу наличных в ДО
     * @request POST:/api/rko-orders/v1/external/cash-withdrawal-order/revoke
     * @secure
     */
    createRevokeCashWithdrawalOrder: (
      data: RevokeCashWithdrawalOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        RevokeCashWithdrawalOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/revoke`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name GetCommissionAmountForCashWithdrawalOrder
     * @summary Получение комиссии для заявки на выдачу наличных
     * @request POST:/api/rko-orders/v1/external/cash-withdrawal-order/commission
     * @secure
     */
    getCommissionAmountForCashWithdrawalOrder: (
      data: GetCommissionAmountRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        GetCommissionAmountResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/commission`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие счёта
     * @name GetAccountOpenOrders
     * @summary Получение заявок на открытие счёта
     * @request GET:/api/rko-orders/v1/external/account-open-order
     * @secure
     */
    getAccountOpenOrders: (
      query: GetAccountOpenOrdersParams,
      params: RequestParams = {}
    ) =>
      this.request<
        GetAccountOpenOrdersResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/account-open-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на открытие счёта
     * @name CreateAccountOpenOrder
     * @summary Создание заявки на открытие счёта
     * @request POST:/api/rko-orders/v1/external/account-open-order
     * @secure
     */
    createAccountOpenOrder: (
      data: AccountOpenOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        AccountOpenOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/account-open-order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetReferenceTypes
     * @summary Получение видов банковских справок
     * @request GET:/api/rko-orders/v1/external/dict/reference-type
     * @secure
     */
    getReferenceTypes: (params: RequestParams = {}) =>
      this.request<ReferenceType[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/reference-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetEsd
     * @summary Получение действующего договора ЕСД клиента
     * @request GET:/api/rko-orders/v1/external/dict/esd
     * @secure
     */
    getEsd: (params: RequestParams = {}) =>
      this.request<Esd, ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/esd`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetDenomination
     * @summary Получение номинала для купюр и монет
     * @request GET:/api/rko-orders/v1/external/dict/denomination
     * @secure
     */
    getDenomination: (params: RequestParams = {}) =>
      this.request<Denomination, ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/denomination`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetDelegates
     * @summary Получение пользователей клиента
     * @request GET:/api/rko-orders/v1/external/dict/delegate
     * @secure
     */
    getDelegates: (params: RequestParams = {}) =>
      this.request<Delegate[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/delegate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetCashSymbols
     * @summary Получение списка кассовых символов
     * @request GET:/api/rko-orders/v1/external/dict/cash-symbol
     * @secure
     */
    getCashSymbols: (params: RequestParams = {}) =>
      this.request<CashSymbol[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/cash-symbol`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetBranches
     * @summary Получение дополнительных офисов филиала клиента
     * @request GET:/api/rko-orders/v1/external/dict/branch
     * @secure
     */
    getBranches: (params: RequestParams = {}) =>
      this.request<Branch[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/branch`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAvailableDays
     * @summary Получение доступных дней для снятия денежных средств
     * @request GET:/api/rko-orders/v1/external/dict/available-days
     * @secure
     */
    getAvailableDays: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/available-days`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAgreement
     * @summary Получение текста клиентского соглашения
     * @request GET:/api/rko-orders/v1/external/dict/agreement
     * @secure
     */
    getAgreement: (query: GetAgreementParams, params: RequestParams = {}) =>
      this.request<Agreement, ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/agreement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAccounts
     * @summary Получение расчётных счетов клиента
     * @request GET:/api/rko-orders/v1/external/dict/account
     * @secure
     */
    getAccounts: (query: GetAccountsParams, params: RequestParams = {}) =>
      this.request<Account[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/account`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAccountTypes
     * @summary Получение типов расчётных счетов
     * @request GET:/api/rko-orders/v1/external/dict/account-type
     * @secure
     */
    getAccountTypes: (params: RequestParams = {}) =>
      this.request<AccountType[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/account-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAccountTariffPlans
     * @summary Получение тарифных планов для расчётных счетов
     * @request GET:/api/rko-orders/v1/external/dict/account-tariff-plan
     * @secure
     */
    getAccountTariffPlans: (params: RequestParams = {}) =>
      this.request<AccountTariffPlan[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/account-tariff-plan`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAccountPeriods
     * @summary Получение расчётных периодов расчётных счетов
     * @request GET:/api/rko-orders/v1/external/dict/account-period
     * @secure
     */
    getAccountPeriods: (params: RequestParams = {}) =>
      this.request<AccountPeriod[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/dict/account-period`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name GetDelegateRoles
     * @summary БД разрешений клиента
     * @request GET:/api/rko-orders/v1/external/db/delegate-roles
     * @secure
     */
    getDelegateRoles: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/delegate-roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name DeleteDelegateRoles
     * @summary Очистка БД разрешений клиента
     * @request DELETE:/api/rko-orders/v1/external/db/delegate-roles
     * @secure
     */
    deleteDelegateRoles: (params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/delegate-roles`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name GetDelegateList
     * @summary БД делегатов
     * @request GET:/api/rko-orders/v1/external/db/delegate-list
     * @secure
     */
    getDelegateList: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/delegate-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name GetClientList
     * @summary БД клиентов
     * @request GET:/api/rko-orders/v1/external/db/client-list
     * @secure
     */
    getClientList: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/client-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name GetBranchList
     * @summary БД филиалов
     * @request GET:/api/rko-orders/v1/external/db/branch-list
     * @secure
     */
    getBranchList: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/branch-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name GetBankRoles
     * @summary БД разрешений банка
     * @request GET:/api/rko-orders/v1/external/db/bank-roles
     * @secure
     */
    getBankRoles: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/bank-roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name DeleteBankRoles
     * @summary Очистка БД разрешений банка
     * @request DELETE:/api/rko-orders/v1/external/db/bank-roles
     * @secure
     */
    deleteBankRoles: (params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/bank-roles`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервис: работа с БД
     * @name GetAccountList
     * @summary БД счетов
     * @request GET:/api/rko-orders/v1/external/db/account-list
     * @secure
     */
    getAccountList: (params: RequestParams = {}) =>
      this.request<string[], ErrorMessage>({
        path: `/api/rko-orders/v1/external/db/account-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на подключение/отключение услуги Проверка контрагентов
     * @name GetContragentReportExample
     * @summary Получение файла PDF с примером отчета о проверке контрагента
     * @request GET:/api/rko-orders/v1/external/contragent-order/example
     * @secure
     */
    getContragentReportExample: (params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/rko-orders/v1/external/contragent-order/example`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetRevokeCashWithdrawalOrderCcb
     * @summary Получение ККБ Отзыва заявки на выдачу наличных В ДО
     * @request GET:/api/rko-orders/v1/external/confirmation/document-ccb/revoke-cash-withdrawal-order
     * @secure
     */
    getRevokeCashWithdrawalOrderCcb: (
      query: GetRevokeCashWithdrawalOrderCcbParams,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/confirmation/document-ccb/revoke-cash-withdrawal-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetReferenceOrderCcb
     * @summary Получение ККБ Заявки на получение банковских справок
     * @request GET:/api/rko-orders/v1/external/confirmation/document-ccb/reference-order
     * @secure
     */
    getReferenceOrderCcb: (
      query: GetReferenceOrderCcbParams,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/confirmation/document-ccb/reference-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetCashWithdrawalOrderCcb
     * @summary Получение ККБ Заявки на выдачу наличных В ДО
     * @request GET:/api/rko-orders/v1/external/confirmation/document-ccb/cash-withdrawal-order
     * @secure
     */
    getCashWithdrawalOrderCcb: (
      query: GetCashWithdrawalOrderCcbParams,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/confirmation/document-ccb/cash-withdrawal-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetAccountOpenOrderCcb
     * @summary Получение ККБ Заявки на открытие счёта
     * @request GET:/api/rko-orders/v1/external/confirmation/document-ccb/account-open-order
     * @secure
     */
    getAccountOpenOrderCcb: (
      query: GetAccountOpenOrderCcbParams,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/confirmation/document-ccb/account-open-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetConteragentServiceOrderCcb
     * @summary Получение ККБ Заявки на услуги получения статуса контрагента
     * @request GET:/api/rko-orders/v1/external/confirmation/document-ccb/contragent-service
     * @secure
     */
    getConteragentServiceOrderCcb: (
      query: GetConteragentServiceOrderCcbParams,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/confirmation/document-ccb/contragent-service`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения для клиента
     * @request GET:/api/rko-orders/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты клиента
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/rko-orders/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name GetOrderAttachment
     * @summary Получение вложения для заявки на выдачу наличных в офисе банка
     * @request GET:/api/rko-orders/v1/external/cash-withdrawal-order/{orderId}/attachment/{attachmentId}
     * @secure
     */
    getOrderAttachment: (
      orderId: string,
      attachmentId: string,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/${orderId}/attachment/${attachmentId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name GetRevokeByRevokeId
     * @summary Получение информации по отзову
     * @request GET:/api/rko-orders/v1/external/cash-withdrawal-order/revoke/{revokeId}
     * @secure
     */
    getRevokeByRevokeId: (
      { revokeId, ...query }: GetRevokeByRevokeIdParams,
      params: RequestParams = {}
    ) =>
      this.request<
        RevokeCashWithdrawalOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/revoke/${revokeId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на выдачу наличных в офисе банка
     * @name GetPrintFormByOrderId
     * @summary Получение печатной формы по заявке
     * @request GET:/api/rko-orders/v1/external/cash-withdrawal-order/print/{orderId}
     * @secure
     */
    getPrintFormByOrderId: (orderId: string, params: RequestParams = {}) =>
      this.request<string[], ErrorMessage | ValidationErrorMessage>({
        path: `/api/rko-orders/v1/external/cash-withdrawal-order/print/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение кредитной сделки
     * @name GetCreditTransactionalById
     * @summary Получение Заявки на заключение кредитной сделки по идентификатору
     * @request GET:/api/rko-orders/v1/external/credit-transaction-order/{orderId}
     * @secure
     */
    getCreditTransactionalById: (
      { orderId, ...query }: GetCreditTransactionalByIdParams,
      params: RequestParams = {}
    ) =>
      this.request<CreditTransactionOrderInfoResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/credit-transaction-order/${orderId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение кредитной сделки
     * @name EditCreditTransactionOrder
     * @summary Редактирование Заявки на заключение кредитной сделки
     * @request PUT:/api/rko-orders/v1/external/credit-transaction-order/{orderId}
     * @secure
     */
    editCreditTransactionOrder: (
      orderId: string,
      data: CreditTransactionOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        CreditTransactionOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/credit-transaction-order/${orderId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение кредитной сделки
     * @name DeleteCreditTransactionOrderById
     * @summary Удаление Заявки на заключение кредитной сделки
     * @request DELETE:/api/rko-orders/v1/external/credit-transaction-order/{orderId}
     * @secure
     */
    deleteCreditTransactionOrderById: (
      orderId: string,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/credit-transaction-order/${orderId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение кредитной сделки
     * @name GetCreditTransactionOrderByPosition
     * @summary Получение Заявки на заключение кредитной сделки
     * @request GET:/api/rko-orders/v1/external/credit-transaction-order
     * @secure
     */
    getCreditTransactionOrderByPosition: (
      query: GetCreditTransactionOrderByPositionParams,
      params: RequestParams = {}
    ) =>
      this.request<
        GetCreditTransactionOrdersResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/credit-transaction-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение кредитной сделки
     * @name CreateCreditTransactionOrder
     * @summary Создание Заявки на заключение кредитной сделки
     * @request POST:/api/rko-orders/v1/external/credit-transaction-order
     * @secure
     */
    createCreditTransactionOrder: (
      data: CreditTransactionOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        CreditTransactionOrderResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/rko-orders/v1/external/credit-transaction-order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение кредитной сделки
     * @name GetGetNextDocumentNumber
     * @summary Получение следующего номера заявки
     * @request GET:/api/rko-orders/v1/external/credit-transaction-order/next-number
     * @secure
     */
    getGetNextDocumentNumber: (params: RequestParams = {}) =>
      this.request<number, ErrorMessage>({
        path: `/api/rko-orders/v1/external/credit-transaction-order/next-number`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение кредитной сделки
     * @name GetPrintFormByCreditTransactionOrderId
     * @summary Получение печатной формы по заявке
     * @request GET:/api/rko-orders/v1/external/credit-transaction-order/print/{orderId}
     * @secure
     */
    getPrintFormByCreditTransactionOrderId: (
      orderId: string,
      params: RequestParams = {}
    ) =>
      this.request<string[], ErrorMessage | ValidationErrorMessage>({
        path: `/api/rko-orders/v1/external/credit-transaction-order/print/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetCreditTransactionOrderCcb
     * @summary Получение ККБ Заявки на заключение кредитной сделки
     * @request GET:/api/rko-orders/v1/external/confirmation/document-ccb/credit-transaction
     * @secure
     */
    getCreditTransactionOrderCcb: (
      query: GetCreditTransactionOrderCcbParams,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-orders/v1/external/confirmation/document-ccb/credit-transaction`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
